import React, { Suspense } from "react";

interface RSuspenseProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

const RSuspense: React.FC<RSuspenseProps> = ({
  children,
  fallback = <></>,
}) => {
  return <Suspense fallback={fallback}>{children}</Suspense>;
};

export default React.memo(RSuspense);
